import React, { FC } from 'react';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './reconfirmModal.module.scss';
const cx = classnames.bind(styles);

interface IReconfirmModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ReconfirmModal: FC<IReconfirmModalProps> = ({ visible, onConfirm, onCancel }) => {
  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>
          작성중인 지원서가 있습니다.
          <br />
          그래도 전형을 진행하시겠습니까?
        </strong>

        <ul className={cx('noticeList')}>
          <li className={cx('listItem')}>해당 포지션에 자동으로 지원 처리가 됩니다. </li>
          <li className={cx('listItem')}>인사담당자가 발송했던 메세지를 모두 확인할 수 있습니다.</li>
          <li className={cx('listItem')}>작성 중인 지원서는 자동으로 삭제됩니다.</li>
        </ul>

        <p className={cx('desc')}>동의하시는 경우 연동하기 버튼을 눌러주세요.</p>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'cancel')} role="button" onClick={onCancel}>
            다음에 하기
          </a>
          <a className={cx('btn', 'confirm')} role="button" onClick={onConfirm}>
            연동 하기
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default ReconfirmModal;
